import { ActionReducer, ActionReducerMap, MetaReducer } from "@ngrx/store";
import {
  AuthenticationState,
  authenticationReducer,
} from "./authentication.reducer";

import { localStorageSync } from "ngrx-store-localstorage";
import { InstructionState, instructionReducer } from "./instruction.reducer";
import {
  instructionDetailsReducer,
  InstructionDetailsState,
} from "./instruction-details.reducer";
import { notificationReducer, NotificationState } from "./notification.reducer";
import { settingsReducer, SettingsState } from "./settings.reducer";

export interface AppState {
  authentication: AuthenticationState;
  instruction: InstructionState;
  instructionDetails: InstructionDetailsState;
  notifications: NotificationState;
  settings: SettingsState;
}

export const REDUCERS: ActionReducerMap<AppState> = {
  authentication: authenticationReducer,
  instruction: instructionReducer,
  instructionDetails: instructionDetailsReducer,
  notifications: notificationReducer,
  settings: settingsReducer,
};

export function localStorageSyncReducer(
  reducer: ActionReducer<AppState>,
): ActionReducer<AppState> {
  return localStorageSync({
    keys: [
      { authentication: ["user"] },
      {
        notifications: [
          "loadedSettings",
          "settings",
          "pushSettings",
          "pushNotificationSubscription",
        ],
      },
    ],

    rehydrate: true,
  })(reducer);
}

export const META_REDUCERS: Array<MetaReducer<AppState>> = [
  localStorageSyncReducer,
];
